import { useEffect } from 'react';

import { useSetTeamsConfigActions } from '../../store/main';
import { type TeamsNavigationConfig } from '../../types';

export const useSetTeamsNavigationConfig = (config: TeamsNavigationConfig): void => {
	const { setNavigationConfig } = useSetTeamsConfigActions();

	useEffect(() => {
		setNavigationConfig(config);
	}, [setNavigationConfig, config]);
};
